<div *ngIf="!isRaiLayout" id="content" class="container-fluid" style="max-width: 1920px; width: 96%; margin-top: 20px; margin-bottom: 80px; min-height: 445px;">
  <router-outlet></router-outlet>
</div>

<div *ngIf="isRaiLayout" id="content" class="container-fluid rai-layout-content">
  <router-outlet></router-outlet>
</div>
